module.exports = __webpack_public_path__ + "static/media/txtbk_other.3d791ea0.svg";